import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {actionCreators as filterActions} from '../../actions/searchBarActions';
import {NavLink,withRouter} from 'react-router-dom';
import {ReactComponent as HomeImage} from '../img/homeImage.svg';
import {ReactComponent as SectionImage} from '../img/sectionImage.svg';
import {ReactComponent as SearchImage} from '../img/searchImage.svg';
import CONSTANTS from '../../constants/constants';
import imgs from '../img/HomeIcon.png';
import './NavBar.scss';

class NavBar extends Component {

	render(){
		return (
			<React.Fragment>
				<div className={['navContainer',this.props.section_open===true?'sectionNavigation':null].join(' ')}>
				{<span className="navItemSpacerEnd"/>}
					{(window.global.content_hub.region===CONSTANTS.WEST
						?[{label:'Home',link:`/home_page_west`,tooltip:(<React.Fragment><img src={imgs} className="homeIcon" alt="home"/></React.Fragment>)},
						{label:'Agronomic Practices',link:`/agronomic_practices`,tooltip:(<React.Fragment>Find tips and best practices<br/>to maximize your crop yield.</React.Fragment>)},
							{label:'On the Farm',link:`/on_farm`,tooltip:(<React.Fragment>Improve your business and<br/>your lifestyle on the farm.</React.Fragment>)},
							
							{label:'Farming Forward',link:`/farming_forward`,tooltip:(<React.Fragment>Maximize sustainable farming practices<br/>and the latest technology.</React.Fragment>)},
				
						]
						:[{label:'Home',link:`/home_page_east`,tooltip:(<React.Fragment><img src={imgs} className="homeIcon" alt="home"/></React.Fragment>)},
						{label:'Agronomic Practices',link:`/agronomic_practices_east`,tooltip:(<React.Fragment>Find tips and best practices<br/>to maximize your crop yield.</React.Fragment>)},
							{label:'On the Farm',link:`/on_farm_east`,tooltip:(<React.Fragment>Improve your business and<br/>your lifestyle on the farm.</React.Fragment>)},
							
							{label:'Farming Forward',link:`/farming_forward_east`,tooltip:(<React.Fragment>Maximize sustainable farming practices<br/>and the latest technology.</React.Fragment>)},
							
						]).map((pillar,index)=>(
							<React.Fragment key={index}>
								{index>0 ?(<span className="navItemSpacer"/>):null}	
								<NavLink to={`${CONSTANTS.PAGE_PILLAR}${pillar.link}`} className="navItem tooltips" activeClassName="active" onClick={()=>this.props.toggle_sections(false)}>
									{pillar.label}
									{pillar.tooltip
										?(<span><div>{pillar.tooltip}</div></span>)
										:null}
								</NavLink>
							</React.Fragment>
						))}
						{<span className="navItemSpacerEnd"/>}	
				</div>
				
				<div className="mobileNavContainer">
					<NavLink to={`${CONSTANTS.PAGE_PILLAR}/`} className="navItem" aria-label="home link">
						<HomeImage/>
					</NavLink>
					<div className="navItem" onClick={()=>this.props.toggle_sections()}>
						<SectionImage/>
					</div>
					<div className="navItem" onClick={()=>this.props.toggle_filters()}>
						<SearchImage/>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

export default connect(
	(state)=>{
    	const {filterData}=state;
    	return {filterData};
  	},
  	(dispatch)=>bindActionCreators({...filterActions},dispatch)
)(withRouter(NavBar));